import { IResidentialComplex } from '../../types/residentials';
import { mapOrder } from '../../utils';
import { residentialComplexesHashSelector, residentialComplexesListSelector } from './getResidentialComplexes';
import { createSelector } from '@reduxjs/toolkit';
import { residentialComplexesIdsSelector } from './residentialComplexesIdsSelector';

export const getFilteredResidentialComplexes = createSelector(
  residentialComplexesListSelector,
  residentialComplexesHashSelector,
  residentialComplexesIdsSelector,
  (list, hash, residentialComplexesIds): IResidentialComplex[] => {
    const order = list.map(complex => Number(complex.id));
    const filteredComplexesIdsByOrder = mapOrder(residentialComplexesIds, order);

    return filteredComplexesIdsByOrder.map(id => hash[id]).filter(Boolean);
  },
);
